module.exports = __webpack_public_path__ + "971243c729690778d61462c645d259f3.svg";